import product1 from '../../images/product-1.jpg';
import product2 from '../../images/product-2.jpg';
import product3 from '../../images/product-3.jpg';
import sweet1 from '../../images/sweet3.jpg';
import sweet2 from '../../images/sweet-2.jpg';
import sweet3 from '../../images/sweet-3.jpg';

export const productData = [

{
	img: product1,
	alt: 'Pizza',
	name: 'Pizza Diavolo',
	desc: 'Tomaten, Peperoni, Oliven',
	price: 'CHF 18.50',
	button: 'In den Warenkorb'

},

{
	img: product2,
	alt: 'Pizza',
	name: 'Pizza Margherita',
	desc: 'Tomatensauce, Mozzarella, Oregano',
	price: 'CHF 16.50',
	button: 'In den Warenkorb'

},

{
	img: product3,
	alt: 'Pizza',
	name: 'Pizza Prosciutto	',
	desc: 'Tomatensauce, Mozzarella, Schinken, Oragano	',
	price: 'CHF 19.50',
	button: 'In den Warenkorb'

},



]

export const productDataTwo = [

{
	img: sweet1,
	alt: 'Cookies',
	name: 'Cookies',
	desc: 'Feiner Dessert',
	price: 'CHF 4.00',
	button: 'In den Warenkorb'

},

{
	img: sweet2,
	alt: 'Donuts',
	name: 'Donuts',
	desc: 'Feine Donuts',
	price: 'CHF 5.50',
	button: 'In den Warenkorb'

},

{
	img: sweet3,
	alt: 'Glace',
	name: 'Glace',
	desc: 'Feine Glaces',
	price: 'CHF 4.50',
	button: 'In den Warenkorb'

},



]